"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPinComponentReferenceFields = exports.processPinReferenceFields = void 0;
const lodash_1 = require("lodash");
const assertions_1 = require("./assertions");
function processPinReferenceFields(pin, fn, options = { ignorePinComponents: false }) {
    if ('layoutParts' in pin.settings) {
        pin.settings.layoutParts = Object.fromEntries((0, lodash_1.compact)(Object.entries(pin.settings.layoutParts).map(([key, value]) => {
            const newValue = fn({ componentId: value });
            if (newValue === undefined) {
                return null;
            }
            return [key, newValue];
        })));
    }
    if ('questionId' in pin.settings && pin.settings.questionId) {
        pin.settings.questionId = fn({ componentId: pin.settings.questionId });
    }
    if (!options.ignorePinComponents) {
        pin.pinComponents.forEach((pinComponent) => {
            processPinComponentReferenceFields(pinComponent, fn);
        });
    }
}
exports.processPinReferenceFields = processPinReferenceFields;
function processPinComponentReferenceFields(pinComponent, fn) {
    if ((0, assertions_1.isHotspotPinComponent)(pinComponent) && pinComponent.settings.linkedPinComponent) {
        pinComponent.settings.linkedPinComponent = fn({ componentId: pinComponent.settings.linkedPinComponent });
    }
}
exports.processPinComponentReferenceFields = processPinComponentReferenceFields;
//# sourceMappingURL=component-reference.processor.js.map